import { Component, OnInit } from '@angular/core';
import { AbstractFieldComponent } from '../../abstract/abstract-field.component';
import {FormFieldService} from '../../../services/form-field.service';

@Component({
  selector: 'app-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss']
})
export class TextareaComponent extends AbstractFieldComponent implements OnInit {

  private _fieldMask;
  private _maskPatterns;
  private _dropSpecialCharacters = false;

  constructor(public formFieldService: FormFieldService) {
    super(formFieldService);
  }

  ngOnInit() {
    this.handleStatusChanges();
  }

  onBlur(event) {
    this.sendFieldClickEvent();
    this.onChange(event);
  }

  get mask() {
    if (this.fieldConfig.maskConfig && this.fieldConfig.maskConfig.mask) {
      this._fieldMask = this.fieldConfig.maskConfig.mask;
    }
    return this._fieldMask;
  }

  get dropSpecialCharacters() {
    if (this.fieldConfig.maskConfig && this.fieldConfig.maskConfig.dropSpecialCharacters) {
      this._dropSpecialCharacters = this.fieldConfig.maskConfig.dropSpecialCharacters;
    }
    return this._dropSpecialCharacters;
  }

  get patterns() {
    if (this.fieldConfig.maskConfig && this.fieldConfig.maskConfig.patterns) {
      this._maskPatterns = this.fieldConfig.maskConfig.patterns;
    }
    return this._maskPatterns;
  }

  private async sendFieldClickEvent() {
    if (this.fieldConfig && this.fieldConfig.analyticsConfig && this.fieldConfig.analyticsConfig.includeFieldValue) {
      const value = await this.valueLabel();
      this.formFieldService.onClick(this.fieldConfig, value);
    }
  }

}
